import React, { useEffect, useState } from "react";
import {AppBar, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Drawer, Grid2, IconButton, List, ListItem, ListItemButton, ListItemText, Paper, Toolbar, Typography, useMediaQuery, useTheme} from "@mui/material";
import "./Navbar.css"
import Input from "../Input/Input";
import { useDispatch} from 'react-redux'
import MenuIcon from "@mui/icons-material/Menu";
import { Link,useNavigate,useLocation } from "react-router-dom";
import LoginSignupPage from "../LoginSignupPage/LoginSignupPage";
import mainlogo from "../../assets/Home/Full logo drak blue opion 2.svg"


const personalinfo = [
  { label: "First Name", name: "firstname" },
  { label: "Last Name", name: "lastname" },
  { label: "Mobile", name: "mobile" },
  { label: "Email", name: "email" },
]

const fields = [
  { label: "Commodity", name: "commodity" },
  { label: "Packing", name: "packing" },
  { label: "Delivery", name: "delivery" },
  { label: "Price", name: "price" },
  { label: "Payment Terms", name: "payment" },
  { label: "Quantity Per Container", name: "quantity" },
  { label: "Other Terms & Conditions", name: "conditions" },
];

const Navbar = () => {
  const location=useLocation()
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const [quoteopen, setQuoteOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [formData, setFormData] = useState({firstname:"",lastname:"",mobile:"",email:"",commodity: "", packing: "", delivery: "",price:"" ,payment: "", quantity: "", conditions: ""});

  const handleDrawerToggle = () => {setMobileOpen((prevState) => !prevState)};
  const handleClickOpen = () => { setQuoteOpen(true); };
  const handleClose = () => { setQuoteOpen(false);setFormData({firstname:"",lastname:"",mobile:"",email:"",commodity: "", packing: "", delivery: "",price:"" ,payment: "", quantity: "", conditions: ""}) };
  const handleChange = (e) => { setFormData({ ...formData, [e.target.name]: e.target.value })};
  const handleSubmit = (e) => { e.preventDefault();console.log("Form Data:", formData);};
  
  const drawerWidth = 240;

  useEffect(()=>{ window.scrollTo({ top: 0, behavior: "smooth" }) },[location.pathname])

  const menuItems = [  { name: "Home", path: "/" }, { name: "About Us", path: "/about" }, { name: "Products", path: "/products" },
                       { name: "Certificates", path: "/certificates" }, { name: "Blogs", path: "/blogs" }, { name: "Contact Us", path: "/contact" },];

  const drawer = (
                  <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
                    <Typography variant="h6" component="div" sx={{width:"max-content",margin:"auto" }}>
                        <Link to="/"> <img src={mainlogo} alt="GBG logo" style={{ height:"50px",marginTop:"10px" }} /> </Link>
                    </Typography>
                    <Divider />
                    <List>
                      {menuItems.map((item) => (
                        <ListItem  key={item} disablePadding>
                          <ListItemButton selected={location.pathname===item.path?true:false} component={Link} to={item.path} sx={{ textAlign: 'center',fontSize:"26px" }}>
                            <ListItemText  primary={item.name} />
                          </ListItemButton>
                        </ListItem>
                      ))}
                    <ListItem disablePadding>
                    <Button variant="contained"  sx={{margin:"auto",backgroundColor:"#154A72",fontSize:"1rem",textTransform:"capitalize"}} onClick={handleClickOpen}>Request a Quote</Button>
                    <Dialog component="form" onSubmit={handleSubmit} open={quoteopen}  onClose={handleClose} maxWidth="lg" fullScreen={isMobile} aria-labelledby="responsive-dialog-title" fullWidth PaperProps={{sx:{width:"90%",height:"90%" },sm:{width:"80%",height:"80%" }}}  >
                      <DialogTitle>REQUEST A QUOTE</DialogTitle>
                      <DialogContent>
                      <Grid2 container sx={{flexDirection: "column",gap:"20px" }}>
                            <Grid2 container component={Paper} elevation={4} sx={{padding:"10px",gap:"10px"}} >
                              <Typography sx={{fontSize:"20px",fontWeight:"600"}}>Personal Info</Typography>
                              <Grid2 sx={{width:"100%"}}>                            
                                {personalinfo.map((field, index) =>{return(
                                <Grid2 key={index} sx={{display: "flex", alignItems:"flex-start", flexDirection:"column" }}>
                                  <label style={{ fontSize: "20px", fontWeight: "500",fontSize:"14px",fontFamily:"sans-serif"}}>{field.label}:</label>
                                  <Input placeholder={field.name} name={field.name} value={formData[field.name]} onChange={handleChange}/>
                                </Grid2>
                              )})}
                              </Grid2>
                            </Grid2>
                            <Grid2 container component={Paper} elevation={4} sx={{padding:"10px",gap:"10px"}} >
                              <Typography sx={{fontSize:"20px",fontWeight:"600"}}>Request Quote</Typography>
                              <Grid2 sx={{width:"100%"}}>  
                              {fields.map((field, index) =>{return(
                                <Grid2 key={index} sx={{display: "flex", alignItems:"flex-start", flexDirection:"column" }}>
                                  <label style={{ fontSize: "20px", fontWeight: "500",fontSize:"14px",fontFamily:"sans-serif"}}>{field.label}:</label>
                                  <Input placeholder={field.name} name={field.name} value={formData[field.name]} onChange={handleChange}/>
                                </Grid2>
                              )})}
                            </Grid2>
                            </Grid2>                   
                            </Grid2>
                      </DialogContent>
                      <DialogActions>
                      <Button type="submit" variant="contained" color="success">Submit</Button>
                      <Button onClick={handleClose}  variant="contained" color="error" >Close</Button>
                      </DialogActions>
                    </Dialog>
                    </ListItem>
                  </List>
            </Box>
            );
            
  const container = window !== undefined ? () => window.document.body : undefined;

  return (
    <AppBar component={Paper} elevation={8} sx={{ backgroundColor: "white", color: "black",position:"sticky",top:"0",borderRadius:"0px" }}>
      <Toolbar  sx={{display:"flex !important",justifyContent:"space-between !important",padding:"0px 5px"}} >
       {/* Mobile Menu  */}
        {isMobile && 
          <>
          <IconButton  color="inherit"  aria-label="open drawer" edge="center" onClick={handleDrawerToggle}  >
            <MenuIcon sx={{fontSize:"30px !important",padding:"0px"}} />
          </IconButton>
            <Drawer container={container} variant="temporary" open={mobileOpen} onClose={handleDrawerToggle} ModalProps={{keepMounted: true}} sx={{ '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth } }}>
              {drawer}
            </Drawer>
          </>
        }

        {/* Logo */}
        <Grid2>
          <Link to="/"> <img src={mainlogo} alt="GBG logo" style={{ height:"50px",marginTop:"10px" }} /> </Link>
        </Grid2>

        {/* Desktop Menu */}
        {!isMobile && (
          <Box sx={{ display: "flex", gap: "20px" }}>
            {menuItems.map((item, index) => (
              <Typography key={index} className={location?.pathname!==item.path?"foottext":"activetext"} variant="body1" component={Link} to={item.path} sx={{ textDecoration: "none", color: "inherit" }}>
                {item.name}
              </Typography>  
            ))}
          </Box>
        )}
        <LoginSignupPage/>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;